/** @file History chords (global): undo Mod+KeyZ, redo Mod+Shift+KeyZ and Mod+KeyY (spec §8.2). */
import type { Binding } from '@pose2d/shortcuts/types';

/** Registered by installHistory while a project is live; collected into bindings.gen.ts for the conflict check. */
export const bindings: Binding[] = [
  { id: 'history.undo', keys: 'Mod+KeyZ', context: 'global' },
  { id: 'history.redo', keys: 'Mod+Shift+KeyZ', context: 'global' },
  { id: 'history.redoAlt', keys: 'Mod+KeyY', context: 'global' },
];
